import clsx from "clsx";
import styles from "./styles.module.css";
import { IButtonTransfer } from "@shared/interfaces";

interface IProps {
  label: string;
  children?: React.ReactNode;
  value?: string;
  onClick?: (event: IButtonTransfer) => void;
}

const PrimaryButton = ({
  label,
  onClick,
  children,
  value = "default_btn",
  ...rest
}: IProps) => {
  if (children) {
    return (
      <button
        onClick={() => onClick && onClick({ type: value })}
        className={clsx(styles.primary_btn, styles.primary_btn_md)}
        {...rest}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      onClick={() => onClick && onClick({ type: value })}
      className={clsx(styles.primary_btn, styles.primary_btn_md)}
      {...rest}
    >
      {label}
    </button>
  );
};

export default PrimaryButton;
